import * as React from 'react';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import ReactPaginate from 'react-paginate';

import { debounce } from 'lodash';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import Fab from 'material-ui/FloatingActionButton';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import ContentAdd from 'material-ui/svg-icons/content/add';
import { compose } from 'recompose';

import type { InjectedRouter } from 'js/lib/connectToRouter';
import connectToRouter from 'js/lib/connectToRouter';

import { Link } from '@coursera/cds-core';

import NewThirdPartyOrganizationModal from 'bundles/internal-enterprise/components/NewThirdPartyOrganizationModal';
import * as apiUtils from 'bundles/internal-enterprise/utils/apiUtils';
import DataCard from 'bundles/internal-ui/components/cards/DataCard';
import LoadingSpinner from 'bundles/internal-ui/components/loadingSpinner/LoadingSpinner';
import Table from 'bundles/internal-ui/components/table/Table';
import type { InjectedNaptime } from 'bundles/naptimejs';
import Naptime from 'bundles/naptimejs';
import ThirdPartyOrganizationsV1 from 'bundles/naptimejs/resources/thirdPartyOrganizations.v1';

import _t from 'i18n!nls/internal-enterprise';

const PAGE_SIZE = 20;

type ThirdPartyOrganization = {
  id: string;
  entityId: string;
  emailDomain: string;
  slug: string;
  name: string;
  loginMethod: string;
  isReal: boolean;
};

type State = {
  filter?: string;
  newThirdPartyOrganizationModalOpen: boolean;
};

type PropsFromCaller = {};
type PropsFromRouter = {
  queryString?: string;
  start: number;
  router: InjectedRouter;
};
type PropsFromNaptime = {
  thirdPartyOrganizations: ThirdPartyOrganization[];
  naptime: InjectedNaptime & {
    paging?: {
      thirdPartyOrganizations?: { total: number };
    };
  };
};

type Props = PropsFromCaller & PropsFromRouter & PropsFromNaptime;

class ThirdPartyOrganizationsHome extends React.Component<Props, State> {
  constructor(props: $TSFixMe) {
    super(props);
    const { queryString } = this.props;
    this.state = {
      filter: queryString,
      newThirdPartyOrganizationModalOpen: false,
    };
  }

  onFilterChange = (filter: string) => {
    this.setState({ filter: filter.length === 0 ? undefined : filter });
    this.onSearchQueryChange();
  };

  onSearchQueryChange = debounce(() => {
    const { filter } = this.state;
    const { router } = this.props;
    router.replace({
      pathname: router.location.pathname,
      query: {
        queryString: filter,
      },
    });
  }, 1000);

  onPageChange = (data: $TSFixMe) => {
    const { filter } = this.state;
    const { router } = this.props;
    router.replace({
      pathname: router.location.pathname,
      query: {
        queryString: filter,
        start: data.selected * PAGE_SIZE,
      },
    });
  };

  onNewThirdPartyOrganizationModalSubmit = () => {
    this.toggleNewThirdPartyOrganizationModal();
  };

  columns = [
    {
      key: 'name',
      name: _t('Name'),
      render: (name: string, org: ThirdPartyOrganizationsV1) => (
        <div>
          <Link href={`/internal/enterprise/organizations/${org.slug}`} target="_blank" rel="noopener noreferrer">
            <strong>{name}</strong>
          </Link>

          <br />
          <small>{org.id}</small>
        </div>
      ),
    },

    {
      key: 'slug',
      name: _t('Slug'),
    },
    {
      key: 'emailDomain',
      name: _t('Email Domain'),
    },
    {
      key: 'entityId',
      name: _t('Entity ID'),
    },
    {
      key: 'organizationType',
      name: _t('Organization Type'),
    },
    {
      key: 'loginMethod',
      name: _t('Login Method'),
    },
    {
      key: 'isReal',
      name: _t('Real'),
      type: 'boolIcon',
    },
  ];

  setOrganizationAsReal = (id: string) => {
    apiUtils.setOrganizationAsReal(id);
  };

  setOrganizationAsFake = (id: string) => {
    apiUtils.setOrganizationAsFake(id);
  };

  downloadSAMLData = (id: string) => {
    apiUtils.downloadOrgMetadata(id);
  };

  toggleNewThirdPartyOrganizationModal = () => {
    const { newThirdPartyOrganizationModalOpen } = this.state;
    this.setState({ newThirdPartyOrganizationModalOpen: !newThirdPartyOrganizationModalOpen });
  };

  renderTable() {
    const { thirdPartyOrganizations, start, naptime } = this.props;

    if (thirdPartyOrganizations !== undefined) {
      const pageCount = Math.ceil((naptime?.paging?.thirdPartyOrganizations?.total ?? 0) / PAGE_SIZE);
      return (
        <div>
          <Table
            columns={this.columns}
            rows={thirdPartyOrganizations}
            initialSortColumn="name"
            sortDescending={false}
          />
          <div className="text-center">
            <ReactPaginate
              previousLabel="previous"
              nextLabel="next"
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.onPageChange}
              containerClassName="pagination"
              forcePage={start / PAGE_SIZE}
              activeClassName="active"
            />
          </div>
        </div>
      );
    } else {
      return <LoadingSpinner />;
    }
  }

  render() {
    const { filter, newThirdPartyOrganizationModalOpen } = this.state;
    return (
      <div className="rc-ThirdPartyOrganizationsHome">
        <Fab
          style={{ position: 'fixed', bottom: 15, right: 15, zIndex: 999 }}
          onClick={this.toggleNewThirdPartyOrganizationModal}
        >
          <ContentAdd />
        </Fab>
        {newThirdPartyOrganizationModalOpen && (
          <NewThirdPartyOrganizationModal
            closeModal={this.toggleNewThirdPartyOrganizationModal}
            onSubmit={this.onNewThirdPartyOrganizationModalSubmit}
          />
        )}
        <DataCard
          title={_t('Third Party Organizations')}
          filterPlaceholder={_t('Search query')}
          filterChildren={
            <Link
              href="https://coursera.atlassian.net/wiki/spaces/ENT/pages/709066824/C3POs+Search+Usage+Guide"
              target="_blank"
              rel="noopener noreferrer"
            >
              Click here to learn more about 3PO search syntax
            </Link>
          }
          filter={filter || ''}
          onFilterChange={this.onFilterChange}
        >
          {this.renderTable()}
        </DataCard>
      </div>
    );
  }
}

export default compose<Props, PropsFromCaller>(
  connectToRouter<PropsFromRouter, PropsFromCaller>((router) => ({
    queryString: router.location.query.queryString,
    start: router.location.query.start ? Number(router.location.query.start) : 0,
    router,
  })),
  Naptime.createContainer<PropsFromNaptime, PropsFromRouter>(({ queryString, start }) => ({
    thirdPartyOrganizations: ThirdPartyOrganizationsV1.finder('byFullTextSearch', {
      params: { queryString: queryString || '*', start, limit: PAGE_SIZE },
      fields: ['entityId', 'emailDomain', 'slug', 'name', 'loginMethod', 'isReal', 'organizationType'],
      required: false,
    }),
  }))
)(ThirdPartyOrganizationsHome);
